import { z } from 'zod';

import { CashDenominationRowsSchema } from './cash-denominations.schema.js';
import { CashOperationIdentityDtoSchema } from './cash-operation-identity.schema.js';
import {
  cashDenominationCorrectionEffectValues,
  type CashDenominationCorrectionDto,
  type CashDenominationCorrectionEffect,
  type CorrectCashDenominationsRequest,
} from './cash-denomination-corrections.dto.js';

const timestampSchema = z.iso.datetime();

export const CashDenominationCorrectionEffectSchema: z.ZodType<CashDenominationCorrectionEffect> =
  z.enum(cashDenominationCorrectionEffectValues);

export const CashDenominationCorrectionDtoSchema: z.ZodType<CashDenominationCorrectionDto> =
  CashOperationIdentityDtoSchema.extend({
    id: z.uuid(),
    cashMovementId: z.uuid(),
    cashLocationId: z.uuid(),
    cashSessionId: z.uuid().nullable(),
    priorRows: CashDenominationRowsSchema,
    correctedRows: CashDenominationRowsSchema,
    effect: CashDenominationCorrectionEffectSchema,
    countBoundaryCheckpointId: z.uuid().nullable(),
    reason: z.string().trim().min(1).max(500),
    createdAt: timestampSchema,
  });

export const CorrectCashDenominationsRequestSchema: z.ZodType<CorrectCashDenominationsRequest> =
  z.object({
    companyId: z.uuid(),
    operationId: z.uuid(),
    cashMovementId: z.uuid(),
    correctedRows: CashDenominationRowsSchema,
    reason: z.string().trim().min(1).max(500),
    occurredAt: timestampSchema.optional(),
  });
